import service from "@/store/services/establishments-service";

export const state = () => ({
  list: {},
  establishment: {},
  establishmentDirectory: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, establishment) => {
    state.establishment = establishment;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((establishment) => {
      commit("SET_RESOURCE", establishment);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((establishment) => {
      commit("SET_RESOURCE", establishment);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((establishment) => {
      commit("SET_RESOURCE", establishment);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },

  activate({ commit, dispatch }, params) {
    return service.activate(params, this.$axios).then((establishment) => {
      commit("SET_RESOURCE", establishment);
    });
  },

  deactivate({ commit, dispatch }, params) {
    return service.deactivate(params, this.$axios).then((establishment) => {
      commit("SET_RESOURCE", establishment);
    });
  },

  pendingSummary({ commit, dispatch }, params) {
    return service.pendingSummary(params, this.$axios);
  },

  couponsBalance({ commit, dispatch }, params) {
    return service.couponsBalance(params, this.$axios);
  },

  istheraProducts({ commit, dispatch }, params) {
    return service.istheraProducts(params, this.$axios);
  },

  istheraProvision({ commit, dispatch }, params) {
    return service.istheraProvision(params, this.$axios);
  },

  istheraProvisionStatus({ commit, dispatch }, params) {
    return service.istheraProvisionStatus(params, this.$axios);
  },

  istheraDeactivateUnlinked({ commit, dispatch }, params) {
    return service.istheraDeactivateUnlinked(params, this.$axios);
  },

  istheraSyncProduct({ commit, dispatch }, params) {
    return service.istheraSyncProduct(params, this.$axios);
  },

  istheraDeactivateProduct({ commit, dispatch }, params) {
    return service.istheraDeactivateProduct(params, this.$axios);
  },

  directory({ commit, dispatch }, params = {}) {
    return service.directory(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  printDirectory({ commit, dispatch }, params = {}) {
    return service.printDirectory(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  establishment: (state) => state.establishment,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((establishment) => ({
      id: establishment.id,
      name: establishment.company_name,
    }));
  },
};

const establishments = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default establishments;
